import { useEffect, useRef } from "react";
import videojs from "video.js";

import "video.js/dist/video-js.css";

export const VideoJS = ({ options, reconnect, onEnded, onReady, ...rest }: any) => {
	const videoRef = useRef<any>(null);
	const playerRef = useRef<any>(null);
	const reconnectInterval = useRef<NodeJS.Timeout | null>(null);

	useEffect(() => {
		if (!playerRef.current) {
			const videoElement = document.createElement("video-js");
			videoElement.classList.add("vjs-big-play-centered");
			videoRef.current.appendChild(videoElement);

			try {
				const player = (playerRef.current = videojs(videoElement, options, () => {
					onReady && onReady(player);
				}));
				player.on("pause", handlePause);
				player.on("waiting", handleWaiting);
				player.on("ended", handleEnded);
				player.on("error", handleError);
				player.on("playing", handlePlaying);
			} catch (_) {}
		} else {
			try {
				const player = playerRef.current;
				player.autoplay(options.autoplay);
				player.src(options.sources);
				player.on("pause", handlePause);
				player.on("waiting", handleWaiting);
				player.on("ended", handleEnded);
				player.on("error", handleError);
				player.on("playing", handlePlaying);
			} catch (_) {}
		}

		// eslint-disable-next-line
	}, [options, videoRef]);

	useEffect(() => {
		const player = playerRef.current;

		return () => {
			if (player && !player.isDisposed()) {
				player.dispose();
				playerRef.current = null;
			}
		};
		// eslint-disable-next-line
	}, [playerRef]);

	function handlePlaying() {
		if (reconnectInterval.current) {
			clearInterval(reconnectInterval.current);
			reconnectInterval.current = null;
		}
	}

	function handlePause() {
		handleReconnect();
	}

	function handleWaiting() {
		handleReconnect();
	}

	function handleEnded() {
		handleReconnect();
		onEnded && onEnded();
	}

	function handleError() {
		handleReconnect();
	}

	function handleReconnect() {
		if (reconnect === true) {
			if (reconnectInterval.current) return;
			reconnectInterval.current = setInterval(() => {
				try {
					const player = playerRef.current;
					player.load();
					player.play().catch(() => {});
				} catch (_) {}
			}, 5000);
		}
	}

	return (
		<div data-vjs-player {...rest}>
			<div ref={videoRef} {...rest} />
		</div>
	);
};

export default VideoJS;
